import gql from 'graphql-tag';

export interface Subregion {
  id: number;
  name: string;
  value: number;
  regionId: number;
  region?: { id: number; name: string } | null;
}

export interface SubregionOutput {
  data: Subregion[];
  recordCount: number;
}

export interface GetSubregionsQueryVariables {
  limit?: number;
  offset?: number;
  order?: string;
  where?: string;
}

export const gqlGetQuery = gql`
  query getSubregions($limit: Int, $offset: Int, $order: String, $where: String) {
    getSubregions(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        value
        regionId
        region {
          id
          name
        }
      }
      recordCount
    }
  }
`;
